import * as angular from 'angular';

// Use case: a select element is used in combination with a search field.
// When the search field is populated, as a result - the select element switches from its current selection
// and displays a "Search Results" option. Once the search text is cleared away the select element will revert to its previous selection
// onSearchToggleChange is required if ng-change is used on the select element
// because it will not be triggered by DOM manipulations
// example: <select .... search-result-option-toggle="$ctrl.searchText">
// Live example: https://dev.aptitutde.com/aptitude/static/home.html#/execute/view/list/filter/activeOpportunities

export class SearchResultOptionToggleController {
  currentSelectedIndex;

  searchResultsOptionLabel = 'Search Results';

  searchResultOptionName = 'searchResultOption';

  searchResultOptionToggle: boolean;

  onSearchToggleChange: any;

  constructor(private $scope, private $element) {
    'ngInject';
  }

  $onInit() {
    angular.element(this.$element).on('change', () => {
      // because we are manipulating the DOM - the model is actually not changing so
      // if the toggle option is enabled - we need to call the same callback used
      // for ng-change so that it will trigger whatever function we normally would on the change event
      if (this.searchResultOptionToggle) {
        this.onSearchToggleChange();
      }
    });
  }

  $onChanges() {
    const searchResultOptionName = this.searchResultOptionName;
    const currentSelectedOption = angular.element(
      `option:selected[name!="${searchResultOptionName}"]`,
      this.$element
    );
    let searchResultOption = angular.element(
      `option[name="${searchResultOptionName}"]`,
      this.$element
    );

    if (currentSelectedOption.length) {
      // Track the index of the currently selected option
      this.currentSelectedIndex = currentSelectedOption.index();
    }

    if (this.searchResultOptionToggle) {
      // Show the hidden Search Results option
      if (!searchResultOption.length) {
        // adding the hidden option element here because by this point we can assume the other options elements have already been rendered
        searchResultOption = angular.element(
          `<option name="${searchResultOptionName}" label="${this.searchResultsOptionLabel}"></option>`
        );
        angular.element(this.$element).append(searchResultOption);
      }

      // ensure that the option is visible and select it
      searchResultOption.show();
      searchResultOption.prop('selected', true);
    } else {
      // Hide Search Results option and revert to previously selected option

      if (this.currentSelectedIndex >= 0) {
        // reselect the previously selected option
        angular
          .element(
            `option:nth-of-type(${this.currentSelectedIndex + 1})`,
            this.$element
          )
          .prop('selected', true);
      }

      searchResultOption.hide();
    }
  }
}

export function SearchResultOptionToggleDirective() {
  return {
    restrict: 'A',
    scope: {}, // this is necessary when using bindToController
    controllerAs: '$ctrl',
    bindToController: {
      searchResultOptionToggle: '<',
      onSearchToggleChange: '&'
    },
    controller: SearchResultOptionToggleController
  };
}
